import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ColectieHero } from '../components/colectie/ColectieHero';
import { ColectieProblem } from '../components/colectie/ColectieProblem';
import { ColectieCurriculum } from '../components/colectie/ColectieCurriculum';
import { ColectieBenefits } from '../components/colectie/ColectieBenefits';
import { ColectieAbout } from '../components/colectie/ColectieAbout';
import { ColectieForWho } from '../components/colectie/ColectieForWho';
import { ColectiePricing } from '../components/colectie/ColectiePricing';
import { ColectieTestimonials } from '../components/colectie/ColectieTestimonials';
import { ColectieFAQ } from '../components/colectie/ColectieFAQ';
// Try to read the target hash from every place it might live when embedded in an iframe (GHL).
function readTargetHash(routerHash: string): string {
  const candidates: string[] = [];
  if (routerHash) candidates.push(routerHash);
  try {
    if (window.location.hash) candidates.push(window.location.hash);
    if (window.location.href.includes('#')) candidates.push('#' + window.location.href.split('#')[1]);
  } catch (e) {}
  try {
    // Parent/top frame may hold the real hash when we're inside an iframe.
    if (window.top && window.top.location && window.top.location.hash) {
      candidates.push(window.top.location.hash);
    }
  } catch (e) {}
  const found = candidates.find(h => h && h.length > 1);
  return found ? found.replace('#', '') : '';
}
export function ColectiePage() {
  const location = useLocation();
  useEffect(() => {
    const id = readTargetHash(location.hash);
    if (!id) return;
    let attempts = 0;
    let cancelled = false;
    const doScroll = () => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        const headerOffset = 100;
        const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
        // Fire a second time shortly after in case layout shifted (images loading).
        setTimeout(() => {
          if (cancelled) return;
          const el2 = document.getElementById(id);
          if (el2) {
            const top2 = el2.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({
              top: top2,
              behavior: 'smooth'
            });
          }
        }, 800);
        return;
      }
      attempts += 1;
      if (attempts < 25) {
        setTimeout(doScroll, 200);
      }
    };
    const timer = setTimeout(doScroll, 300);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [location.hash]);
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2294">
      <Header data-id="element-2295" />
      <main data-id="element-2296">
        <ColectieHero data-id="element-2297" />
        <ColectieProblem data-id="element-2298" />
        <ColectieCurriculum data-id="element-2299" />
        <ColectieBenefits data-id="element-2300" />
        <ColectieAbout data-id="element-2301" />
        <ColectieForWho data-id="element-2302" />
        <ColectiePricing data-id="element-2303" />
        <ColectieTestimonials data-id="element-2304" />
        <ColectieFAQ data-id="element-2305" />
      </main>
      <Footer data-id="element-2306" />
    </div>;
}